import type { RouteObject } from "react-router-dom";
import ChannelAccountDetailRouter from "@/pages/channel/ChannelAccountDetailRouter";
import ChannelAccounts from "@/pages/channel/ChannelAccounts";
import ChannelSessions from "@/pages/channel/ChannelSessions";
import Channels from "@/pages/channel/Channels";

export const channelRoutes: RouteObject[] = [
  { path: "/channels", element: <Channels /> },
  { path: "/channel-accounts", element: <ChannelAccounts /> },
  {
    path: "/channel-accounts/:accountId",
    element: <ChannelAccountDetailRouter />,
  },
  { path: "/channels/:channelId/accounts", element: <ChannelAccounts /> },
  { path: "/channel-sessions", element: <ChannelSessions /> },
  {
    path: "/channels/:channelId/accounts/:accountId/sessions",
    element: <ChannelSessions />,
  },
];
